import { useEffect, useState } from 'react'
import axios from 'axios'
import _, { filter } from 'lodash';

//const ApiUrl = 'https://34c7-106-51-3-217.ngrok.io'
const ApiUrl = 'https://wso45uuvw2.execute-api.us-east-1.amazonaws.com/prod/search'//URL for elastic search call

let cancelToken //stores previous axios request cancel token

const fieldConfig = {
    f_facetFields: {
        "menu_color": [
            {
                "type": "value",
                "name": "color",
                "sort": {
                    "value": "asc"
                },
                "size": 250
            }
        ],
        "menu_style": [
            {
                "type": "value",
                "name": "style",
                "sort": {
                    "value": "asc"
                },
                "size": 250
            }
        ],
        "instock": [
            {
                "type": "value",
                "name": "instock",
                "sort": {
                    "value": "asc"
                }
            }
        ],
        "brand": [
            {
                "type": "value",
                "name": "designer_brands",
                "sort": {
                    "value": "asc"
                },
                "size": 250
            }
        ],
        "menu_content": [
            {
                "type": "value",
                "name": "content",
                "sort": {
                    "value": "asc"
                },
                "size": 250
            }
        ],
        "menu_suggested_use": [
            {
                "type": "value",
                "name": "suggested_use",
                "sort": {
                    "value": "asc"
                },
                "size": 250
            }
        ]
    },
    w_facetFields: {
        "menu_color": [
            {
                "type": "value",
                "name": "color",
                "sort": {
                    "value": "asc"
                },
                "size": 250
            }
        ],
        "menu_style": [
            {
                "type": "value",
                "name": "style",
                "sort": {
                    "value": "asc"
                },
                "size": 250
            }
        ],
        "instock": [
            {
                "type": "value",
                "name": "instock",
                "sort": {
                    "value": "asc"
                }
            }
        ],
        "brand": [
            {
                "type": "value",
                "name": "designer_brands",
                "sort": {
                    "value": "asc"
                },
                "size": 250
            }
        ]
    },
    searchFields: {
        "p_title": {},
        "p_vendor": {},
        "sku": {}
    },
    groupFields: {
        "field": "product_id"
    },
    sortFields: [
        {
            "p_discontinued": "asc"
        },
        {
            "p_created_at": "desc"
        },
        {
            "_score": "desc"
        },
        {
            "hasimage": "desc"
        }
    ],
    resultFields: {
        "id": {
            "raw": {}
        },
        "p_title": {
            "raw": {}
        },
        "title": {
            "raw": {}
        },
        "p_image_src": {
            "raw": {}
        },
        "p_handle": {
            "raw": {}
        },
        "p_vendor": {
            "raw": {}
        },
        "sku": {
            "raw": {}
        },
        "price": {
            "raw": {}
        },
        "compare_at_price": {
            "raw": {}
        },
         "p_status": {
            "raw": {}
        }
    }
}

export default function useInfiniteLoad(filters, pseudoFilter, Page, collectionHandle) {

    const [loader, setLoader] = useState(true)
    // const [error, setError] = useState(false)
    const [hasMore, setHasMore] = useState(false)
    const [products, setProducts] = useState([])
    const [facets, setFacets] = useState([])
    const pageSize = 12

    useEffect(() => {
        setProducts([])
    }, [filters])

    useEffect(() => {
        getFacet(filters)
    }, [filters, Page])

    const getFacet = async (filter) => {

        try {
            //Check if there are any previous pending requests
            if (typeof cancelToken != typeof undefined) {
                cancelToken.cancel("Operation canceled due to new request.")
            }
            //Save the cancel token for the current request
            cancelToken = axios.CancelToken.source()

            setLoader(true)

            let filterFields = {
                "all": [
                    {
                        "collection_handles": [collectionHandle]
                    }
                ]
            }
            if (filter) {
                filterFields = filter
            }

            let facetFields = collectionHandle.toLowerCase().includes("fabrics") ? fieldConfig.f_facetFields : fieldConfig.w_facetFields

            let query = {
                "search_fields": fieldConfig.searchFields,
                "query": "",
                "page": {
                    "current": Page,
                    "size": pageSize
                },
                "sort": fieldConfig.sortFields,
                "filters": filterFields,
                // "group": groupFields,
                "result_fields": fieldConfig.resultFields,
                "facets": facetFields
            }
            var config = {
                method: 'post',
                url: `${ApiUrl}`,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(query),
                cancelToken: cancelToken.token
            };

            const searchResponse = await axios(config)
            const resData = JSON.parse(searchResponse.data.body)
           // console.log("resData=>", resData)
            if (resData?.result) {
                let facetObj = resData.data.facets
                let newProducts = resData.data.results
               // let totalPage = resData.data.meta.page.total_pages
                let facetArray = []
                //code to merge new Facets count from api with old Facets
                //check if facet value already there forms facets array object,else merges new facet count with old
                if (facets.length > 0) {
                    let newFacets = [...facets]
                    newFacets.forEach(f => {
                        // if (filters[f.facename]?.length > 1) {

                        // }
                        // else { 
                        if (!(pseudoFilter[f.facetname] && pseudoFilter[f.facetname].length > 0)) {
                            let alteredCount = []
                            f.data.forEach(d => {
                                d.count = 0
                                alteredCount.push(d)
                            })
                            let newArr = _.values(_.merge(
                                _.keyBy(alteredCount, 'value'),
                                _.keyBy(facetObj[f.facetname][0].data, 'value'),
                            ));
                            f.data = newArr
                        }
                        //}

                    })
                    facetArray = newFacets
                }
                else {
                    Object.keys(facetObj).forEach((key) => {
                        if (key != "p_vendor" && key != "mainproducts" && key != "isdefault" && key != "instock") {
                            facetObj[key][0]["facetname"] = key
                            facetArray.push(facetObj[key][0])
                        }
                    });
                }

                setLoader(false)
                setFacets(_.sortBy(facetArray, 'facetname') || [])
                //setFacets(facetArray || [])
                setProducts(prevProducts => {
                    return [...prevProducts, ...newProducts]
                })//lazy binding products
                setHasMore(newProducts.length > 0)
            }
            else {
                setLoader(false)
            }
        }
        catch (error) {
            console.log("error :", error.message)
        }
    }

    return { loader, facets, products, hasMore, setFacets }
}
